import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { faTimes, faInfoCircle } from '@fortawesome/pro-light-svg-icons';


export interface InputData {
  value: string | number
  valid: boolean
}

@Component({
  selector: 'app-input-list-group',
  styleUrls: ['./input-list-group.component.scss'],
  templateUrl: './input-list-group.component.html',
  // encapsulation: ViewEncapsulation.None
})
export class InputListGroupComponent {
  @Input() formData: {
    label: string;
    type?: string;
    placeholder?: string;
  }
  @Input() formCtrlName: string;
  @Input() formGrp: FormGroup;
  @Input() caption: string;
  @Input() lists: string[] = []

  @Output() removedElement = new EventEmitter()

  icons = {times: faTimes, info: faInfoCircle}
  inputValue = '';

  addToList() {
    if(this.inputValue) {
      this.lists.push(this.inputValue);
      this.inputValue = '';
      this.setFormValue();
    }
  }
  removeFromList(i: number, item: string) {
    this.lists = this.lists.filter((item , listIndex) => i !== listIndex);
    this.removedElement.emit(item)
    this.setFormValue()
  }

  setFormValue() {
    if(this.formCtrlName && this.formGrp) {
      this.formGrp.get(this.formCtrlName)?.setValue(this.lists)
    }
  }


}
